import hmImage from '../images/project/hm.png';
import tarsusImage from '../images/project/tarsus-belediyesi.png';
import tubitakImage from '../images/project/tubitak.png';
import canAkademiImage from '../images/project/can-akademi.png';
import qrImage from '../images/project/qr-tarayici.png';
import adanaKentImage from '../images/project/adana-kent-clone.png';
import basicLinkImage from '../images/project/basic-link-app.png';
import fiberInternetImage from '../images/project/fiber-internet.png';
import nextGlobalImage from '../images/project/next-global.png';
import ocakbasiImage from '../images/project/ocakbasi-qr.png';
import portfolioImage from '../images/project/portfolio.png';
import songulImage from '../images/project/songul-kınık.jpg';
import endlessImage from '../images/project/endless-software.png';
import adafonImage from '../images/project/adafon.png';
import sujetImage from '../images/project/sujet-makina.png';
import kuyasImage from '../images/project/kuyas.png';
import dduzenImage from '../images/project/dduzen.png';

const projectsData = {
   mobile: [
      {
         id: 1,
         title: "H&M Grup Stok ve Satış Takip Uygulaması",
         image: hmImage,
         description: "Adana'da hizmet veren HM Grup Telekomünikasyon için geliştirilen satış ve stok takip masaüstü uygulaması",
         category: "mobil",
         technologies: ["Flutter", "Firebase"],
         githubLink: "https://github.com/janberkaltay/",
         playStoreLink: null
      },
      {
         id: 2,
         title: "Tarsus Belediyesi Talep Takip Uygulaması",
         image: tarsusImage,
         description: "Tarsus İlçe Belediyesine Gelen Taleplerin Kurum İçin Takibini Sağlayan Mobil Uygulama",
         category: "mobil",
         technologies: ["Flutter", "Firebase"],
         githubLink: "https://github.com/janberkaltay/",
         playStoreLink: null
      },
      {
         id: 3,
         title: "Hayvan Barınaklarındaki Hayvanların Sahiplendirilmesi",
         image: tubitakImage,
         description: "TÜBİTAK 2209-A Projem Kapsamında Geliştirdiğimiz Uygulama",
         category: "mobil",
         technologies: ["Flutter", "Firebase", "Google Maps API"],
         githubLink: "https://github.com/janberkaltay/",
         playStoreLink: "https://www.janberkaltay.dev/t%C3%BCbitak"
      },
      {
         id: 4,
         title: "Can Akademi - Can Mobil",
         image: canAkademiImage,
         description: "Adana'da bulunan Can Akademi'ye özel eğitim uygulaması",
         category: "mobil",
         technologies: ["Flutter", "Firebase", "PDF Viewer"],
         githubLink: "https://github.com/janberkaltay/",
         playStoreLink: "https://play.google.com/store/apps/details?id=com.canmobil.can_akademi"
      },
      {
         id: 5,
         title: "QR Kod Tarayıcı",
         image: qrImage,
         description: "Hızlı ve güvenilir QR kod tarama uygulaması",
         category: "mobil",
         technologies: ["Flutter", "QR Scanner", "Clipboard"],
         githubLink: "https://github.com/janberkaltay/",
         playStoreLink: "https://play.google.com/store/apps/details?id=com.endlesstech.qr_tarayici"
      },
      {
         id: 6,
         title: "Flutter Adana Kent Full AppClone",
         image: adanaKentImage,
         description: "Adana Akıllı Kent uygulamasının tam klonu",
         category: "mobil",
         technologies: ["Flutter", "Dart", "UI/UX"],
         githubLink: "https://github.com/janberkaltay/Flutter-Adana-Akilli-Kent-Full-AppClone",
         playStoreLink: null
      },
      {
         id: 7,
         title: "Flutter Basic Link App",
         image: basicLinkImage,
         description: "Temel link paylaşım ve yönetim uygulaması",
         category: "mobil",
         technologies: ["Flutter", "Firebase", "Dynamic Links"],
         githubLink: "https://github.com/janberkaltay/Flutter-Basic-Link-App",
         playStoreLink: null
      }
   ],
   web: [
      {
         id: 8,
         title: "Kuyaş Soğuk Hava Depoları",
         image: kuyasImage,
         description: "Adana bölgesinde bulunan Soğuk Hava Deposu, Mimarlık ve Lojistik alanlarında faaliyet göstermekte olan firma için geliştirilen websitesi.",
         category: "web",
         technologies: ["React.js", "Material UI", "SEO", "Responsive Design"],
         githubLink: "https://github.com/janberkaltay/",
         liveLink: "https://www.kuyassogukhavadepolari.com/"
      },
      {
         id: 9,
         title: "Demirdüzen Hukuki Danışmanlık ve Avukatlık Bürosu",
         image: dduzenImage,
         description: "Adana bölgesinde faaliyet gösteren Demirdüzen Hukuki Danışmanlık ve Avukatlık Bürosu için geliştirilmiş websitesi",
         category: "web",
         technologies: ["React.js", "Material UI", "Responsive Design"],
         githubLink: "https://github.com/janberkaltay/",
         liveLink: "https://www.demirduzenhukukburosu.com/"
      },
      {
         id: 10,
         title: "Fiber İnternet Başvuru Merkezi",
         image: fiberInternetImage,
         description: "Adana'da hizmet vermekte olan Fiber İnternet Başvuru Merkezi için geliştirilmiş olan özel websitesi",
         category: "web",
         technologies: ["React.js", "Firebase", "SEO", "Responsive Design"],
         githubLink: "https://github.com/janberkaltay/",
         liveLink: "https://www.fiberinternetim.com.tr/"
      },
      {
         id: 11,
         title: "Next Global",
         image: nextGlobalImage,
         description: "Adana merkezli global vermekte olan Next Global için geliştirilmiş olan özel websitesi",
         category: "web",
         technologies: ["React.js", "SEO", "Responsive Design"],
         githubLink: "https://github.com/janberkaltay/",
         liveLink: "https://www.nextglobal.com.tr/"
      },
      {
         id: 12,
         title: "Konya Ocakbaşı QR Menü",
         image: ocakbasiImage,
         description: "Konya'da Bulunan Ocakbaşı İşletmesine Özel QR Menü Sistemi",
         category: "web",
         technologies: ["React.js", "Firebase", "Responsive Design"],
         githubLink: "https://github.com/janberkaltay/",
         liveLink: "https://ocakbasi-qr.vercel.app/home"
      },
      {
         id: 13,
         title: "Portfolyom",
         image: portfolioImage,
         description: "Kişisel portfolyo websitesi - Tasarım ve geliştirme",
         category: "web",
         technologies: ["React.js", "JavaScript", "Responsive Design"],
         githubLink: "https://github.com/janberkaltay/Janberk-Altay-Portfolio",
         liveLink: "https://janberkaltay.dev/"
      },
      {
         id: 14,
         title: "Songül Kınık Portfolyo",
         image: songulImage,
         description: "Eğitimci - Sanatçı Songül Kınık İçin Hazırlanan Profesyonel Websitesi",
         category: "web",
         technologies: ["React.js", "Bootstrap"],
         githubLink: "https://github.com/janberkaltay/",
         liveLink: "https://songulknk.art/"
      },
      {
         id: 15,
         title: "Endless Software Websitesi",
         image: endlessImage,
         description: "Endless Software için modern ve responsive kurumsal websitesi",
         category: "web",
         technologies: ["React.js", "Tailwind CSS"],
         githubLink: "https://github.com/janberkaltay/",
         liveLink: "https://endlesstech.org/"
      },
      {
         id: 16,
         title: "Güzel Adana Fiber Optik",
         image: adafonImage,
         description: "Güzel Adana Fiber Optik için ticari websitesi",
         category: "web",
         technologies: ["React.js", "Php", "Responsive Design"],
         githubLink: "https://github.com/janberkaltay/",
         liveLink: "https://www.adafon.com.tr/"
      },
      {
         id: 17,
         title: "Sujet Makina",
         image: sujetImage,
         description: "Adana'da hizmet veren Sujet Makina için tasarlanan Profesyonel Websitesi",
         category: "web",
         technologies: ["WordPress", "Php"],
         githubLink: "https://github.com/janberkaltay/",
         liveLink: "https://www.sujetmakina.com/"
      },
   ]
};

export const getAllProjects = () => {
   return [...projectsData.web, ...projectsData.mobile];
};

export const getProjectsByCategory = (category) => {
   if (category === 'all') return getAllProjects();
   return projectsData[category] || [];
};

export const getProjectById = (id) => {
   const allProjects = getAllProjects();
   return allProjects.find(project => project.id === id);
};

export const getMobileProjects = () => projectsData.mobile;
export const getWebProjects = () => projectsData.web;

export default projectsData;